import { useQuery } from '@tanstack/react-query';
import { fetchRankings } from '../api/rankings';
import { RankingType } from '../types/rankings';

export function useRankings(type: RankingType) {
  return useQuery({
    queryKey: ['rankings', type],
    queryFn: () => fetchRankings(type),
    staleTime: 1000 * 60 * 5, // 5분
  });
}

